import { useShopHistoricQuery } from "@/query/historicQuery"
import { Filter, Search } from "lucide-react"
import { Button } from "../ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog"
import { Input } from "../ui/input"
import { Label } from "../ui/label"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select"
import { getActionTypeInfo } from "./utils/historicUtils"

type HistoricFilterModalProps = {
  isOpen: boolean
  onClose: () => void
  searchTerm: string
  onSearchTermChange: (value: string) => void
  selectedActionType: string
  onActionTypeChange: (value: string) => void
  onResetFilters: () => void
}

export const HistoricFilterModal = ({
  isOpen,
  onClose,
  searchTerm,
  onSearchTermChange,
  selectedActionType,
  onActionTypeChange,
  onResetFilters,
}: HistoricFilterModalProps) => {
  const { shopHistoric } = useShopHistoricQuery()

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Filter className="h-5 w-5" />
            Filtres de l'historique
          </DialogTitle>
          <DialogDescription>
            Filtrez l'historique par type d'action ou par recherche
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="search">Recherche</Label>
            <div className="relative">
              <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
              <Input
                id="search"
                placeholder="Rechercher dans l'historique..."
                value={searchTerm}
                onChange={(e) => onSearchTermChange(e.target.value)}
                className="pl-10"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="actionType">Type d'action</Label>
            <Select
              value={selectedActionType}
              onValueChange={onActionTypeChange}
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">Toutes les actions</SelectItem>
                {shopHistoric?.map((item) => {
                  const { label } = getActionTypeInfo(item)
                  return (
                    <SelectItem
                      key={item.historicType}
                      value={item.historicType}
                    >
                      {label}
                    </SelectItem>
                  )
                })}
              </SelectContent>
            </Select>
          </div>
        </div>

        <DialogFooter className="flex justify-between">
          <Button variant="outline" onClick={onResetFilters}>
            Réinitialiser
          </Button>
          <Button onClick={onClose}>Appliquer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
